/**
 * 执行一个函数，并返回结果（相对优雅的立即执行函数）
 * @param fn 要执行的函数
 * @returns 结果
 */
export function invoke<T>(fn: () => T) {
  return fn();
}

export const isApp = () => {
  return /bybit_app/.test(navigator.userAgent.toLowerCase());
};

export const isBrowser = typeof window !== 'undefined';

export const isIOS = () => {
  return isBrowser && /iphone/.test(navigator.userAgent.toLowerCase());
};

export const stringBrChange = (str: string) => {
  return str.replace(/[\n\r]/g, '<br>');
};
export const stringNbspChange = (str: string) => {
  return str.replace(/ {3,}/g, '&nbsp;&nbsp;&nbsp;&nbsp;');
};

export const randomString = () => {
  return Math.random().toString(36).substring(2);
};

/**
 * parse json string without throwing error
 *
 * @param {string } str JSON string
 * @param {any} defaultValue default Value
 */
export function safeJsonParse<T>(str: string, defaultValue: T) {
  try {
    return JSON.parse(str) as T;
  } catch {
    return defaultValue;
  }
}

export const isMobile = () => {
  if (isBrowser) {
    return /(ipod|ipad|iphone|android|mobile)/.test(
      navigator.userAgent.toLowerCase()
    );
  }
  return false;
};

export const getQuery = (name: string) => {
  const params = location.search.slice(1);
  const data: Record<string, string> = params
    .split('&')
    .filter(Boolean)
    .reduce((acc, cur) => {
      const [key, value] = cur.split('=');
      acc[key] = value;
      return acc;
    }, {});
  if (data != null) {
    return data[name];
  }
  return '';
};

export const addDarkTheme = () => {
  // moly-theme-dark
  const doc = document.documentElement;
  doc?.classList.add('moly-theme-dark');
};
